import React, { createContext, useState, useEffect, useContext } from "react";

const CartContext = createContext();

export const CartProvider = ({ children }) => {
    const [cartItems, setCartItems] = useState(() => {
        // Lấy giỏ hàng từ localStorage nếu có
        if (typeof window !== "undefined") {
            const savedCart = localStorage.getItem("cart");
            return savedCart ? JSON.parse(savedCart) : [];
        }
        return [];
    });

    // Lưu giỏ hàng vào localStorage khi có thay đổi
    useEffect(() => {
        if (typeof window !== "undefined") {
            localStorage.setItem("cart", JSON.stringify(cartItems));
        }
    }, [cartItems]);

    // Thêm sản phẩm vào giỏ hàng
    const addToCart = (product, variant, quantity = 1) => {
        setCartItems((prevItems) => {
            // Kiểm tra xem sản phẩm đã tồn tại trong giỏ hàng chưa
            const existingItemIndex = prevItems.findIndex(
                (item) => item.variantId === variant.id
            );

            if (existingItemIndex >= 0) {
                // Nếu đã tồn tại, tăng số lượng
                const updatedItems = [...prevItems];
                updatedItems[existingItemIndex].quantity += quantity;
                return updatedItems;
            } else {
                // Nếu chưa tồn tại, thêm mới
                return [
                    ...prevItems,
                    {
                        productId: product.id,
                        productName: product.name,
                        variantId: variant.id,
                        price: variant.price,
                        attributeSummary: variant.attribute_summary,
                        quantity,
                        mediaUrl:
                            product.media && product.media.length > 0
                                ? product.media[0].media_url
                                : null,
                    },
                ];
            }
        });
    };

    // Cập nhật số lượng sản phẩm
    const updateQuantity = (variantId, quantity) => {
        if (quantity <= 0) {
            removeFromCart(variantId);
            return;
        }

        setCartItems((prevItems) =>
            prevItems.map((item) =>
                item.variantId === variantId ? { ...item, quantity } : item
            )
        );
    };

    // Xóa sản phẩm khỏi giỏ hàng
    const removeFromCart = (variantId) => {
        setCartItems((prevItems) =>
            prevItems.filter((item) => item.variantId !== variantId)
        );
    };

    // Xóa toàn bộ giỏ hàng
    const clearCart = () => {
        setCartItems([]);
    };

    // Tính tổng số sản phẩm trong giỏ hàng
    const getTotalItems = () => {
        return cartItems.reduce((total, item) => total + item.quantity, 0);
    };

    // Tính tổng tiền
    const getTotalPrice = () => {
        return cartItems.reduce(
            (total, item) => total + item.price * item.quantity,
            0
        );
    };

    return (
        <CartContext.Provider
            value={{
                cartItems,
                addToCart,
                updateQuantity,
                removeFromCart,
                clearCart,
                getTotalItems,
                getTotalPrice,
            }}
        >
            {children}
        </CartContext.Provider>
    );
};

export const useCartContext = () => {
    const context = useContext(CartContext);
    if (!context) {
        throw new Error("useCartContext must be used within a CartProvider");
    }
    return context;
};

export default CartContext;
